import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={13}
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_17258_7291)">
      <path
        d="M9.81837 10.3184C8.8405 11.2962 7.49132 11.9 6 11.9C4.50868 11.9 3.1595 11.2962 2.18162 10.3184C1.20376 9.3405 0.6 7.99132 0.6 6.5C0.6 5.00868 1.20376 3.6595 2.18163 2.68162C3.1595 1.70376 4.50868 1.1 6 1.1C7.49132 1.1 8.8405 1.70376 9.81836 2.68162C10.7962 3.6595 11.4 5.00868 11.4 6.5C11.4 7.99132 10.7962 9.3405 9.81837 10.3184Z"
        fill="#E0EDEF"
        stroke="#E0EDEF"
        strokeWidth={1.2}
      />
      <path
        d="M6 3.375C6.27614 3.375 6.5 3.59886 6.5 3.875C6.5 4.15114 6.27614 4.375 6 4.375C5.72386 4.375 5.5 4.15114 5.5 3.875C5.5 3.59886 5.72386 3.375 6 3.375Z"
        fill="#212326"
        stroke="#212326"
        strokeWidth={0.25}
      />
      <path d="M6.125 9V5.5H5.875H5.625" fill="#212326" />
      <path d="M6.125 9V5.5H5.875H5.625" stroke="#212326" />
      <path d="M5.25 9H7H5.25Z" fill="#212326" />
      <path d="M5.25 9H7" stroke="#212326" />
    </g>
    <defs>
      <clipPath id="clip0_17258_7291">
        <rect
          width={12}
          height={12}
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgComponent;
